<script lang="ts">
import { defineAsyncComponent, defineComponent } from 'vue';
import { Constants } from '@fibl/oxs-common';

const RootOxs = defineAsyncComponent(() => import('@/components/layout/layout-oxs.vue'));
const RootOxsSelect = defineAsyncComponent(
	() => import('@/components/layout/layout-oxs-select.vue'),
);
const RootRdb = defineAsyncComponent(() => import('@/components/layout/layout-rdb.vue'));
const RootAdmin = defineAsyncComponent(() => import('@/components/layout/layout-admin.vue'));

export default defineComponent({
	name: 'App',
	components: {},
	computed: {
		maintenance() {
			return this.$globalStore.maintenance;
		},
		root() {
			const website = this.$globalStore.websiteStore.websiteCode;
			switch (website) {
				case Constants.WEB_OXS: {
					return RootOxs;
				}
				case Constants.WEB_ADMIN: {
					return RootAdmin;
				}
				case Constants.WEB_RDB: {
					return RootRdb;
				}
				default: {
					return RootOxsSelect;
				}
			}
		},
		locale() {
			return this.$globalStore.websiteStore.locale;
		},
		titleKey(): string {
			return this.$route.meta.title_key as string || '';
		}
	},
	watch: {
		locale() {
			if (this.titleKey && this.$te(this.titleKey)) {
				document.title = this.$t(this.titleKey);
			}
		},
		titleKey() {
			if (this.titleKey && this.$te(this.titleKey)) {
				document.title = this.$t(this.titleKey);
			} else {
				document.title = Constants.DEFAULT_TITLE;
			}
		}
	}
});
</script>

<template>
	<div v-if="maintenance">
		<el-card style="padding: 3rem">
			<template #header>{{ $t('view.maintenance.title') }}</template>
			<p>{{ $t('view.maintenance.text1') }}</p>
			<p>{{ $t('view.maintenance.text2') }}</p>
		</el-card>
	</div>
	<component
		:is="root"
		v-else
	/>
</template>
